import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Device } from 'src/app/_models/device';
import { DeviceSetupStatus } from 'src/app/_models/device-setup-status';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-device-setup-row',
  templateUrl: './device-setup-row.component.html',
  styleUrls: ['./device-setup-row.component.scss'],
  imports: [MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceSetupRowComponent {
  DeviceSetupStatus = DeviceSetupStatus;

  /** The calibration summary for the device (required) */
  device = input<Device>();

  /** Whether the device setup is complete (required) */
  deviceComplete = input<boolean>();

  /** Whether to show the morbidostat warning (optional) */
  showMorbidostatWarning = input<boolean>();
}
